export default __webpack_public_path__ + "heart.98653.svg";